/* jshint esversion: 8 */
/* jshint node: true */

import React, { Component } from "react";
import DashboardPageContainer from "../DashboardPageContainer/DashboardPageContainer";
import loadingSvgImage from "../../../assets/images/loading.svg";
import PropTypes from "prop-types";
// import logger from "services/LoggingService";
import ReactGA from "react-ga4";
import { getS3Url } from "../../../common";

class UserGuidePage extends Component {
  constructor(props) {
    super(props);

    ReactGA.send({
      hitType: "pageview",
      page: "/components/MainContentArea/UserGuidePage/UserGuidePage.js",
      title: "Spotlight User Guide",
    });

    this.libOpen = false;
    this.reload = false;

    this.state = {
      iFrameLoadedSuccessfully: false,
    };
    this.iFrameLoaderListener = this.iFrameLoaderListener.bind(this);
    this.refreshIFrameContents = this.refreshIFrameContents.bind(this);
    this.timerID = null;
    this.keyID = 1;

    // Load the User Guide PDF from the media server using the same pattern as other downloads
    const s3path = getS3Url();
    this.guideURL = `${s3path}Spotlight%20User%20Guide.pdf`;
    
  }

  iFrameLoaderListener() {
    this.setState({
      iFrameLoadedSuccessfully: true,
    });
  }

  refreshIFrameContents() {
    /* Note: In order to trigger a re-render of the iFrame using this.forceUpdate(), something within the iFrame needs to change
            In this case, I am forcing an update by changing the key of the iFrame */
    this.keyID = this.keyID + 1;
    this.forceUpdate();
  }

  componentWillUnmount() {
    window.clearInterval(this.timerID);
  }

  componentDidMount() {
    /* Note: Set this refreshTimeInterval to a value < the Dashboard 'web user idle session', currently set to 176 minutes */
    const refreshTimeInterval = 9900000; // 2 Hours 45 Minutes
    // let refreshTimeInterval = 240000;   //4 minutes - Can be used for TESTING
    this.timerID = window.setInterval(
      this.refreshIFrameContents,
      refreshTimeInterval
    );
  }

  checkForRefresh() {
    if (!this.libOpen) {
      this.libOpen = true;
    } else if (!this.reload) {
      this.reload = true;
    } else {
      this.keyID = this.keyID + 1;
      this.reload = false;
    }
  }

  render() {
    this.checkForRefresh();

    const loadingSpinnerStyle = {
      textAlign: "center",
    };

    let iFrameNotLoadingInfoMessage = null;
    if (!this.state.iFrameLoadedSuccessfully) {
      iFrameNotLoadingInfoMessage = (
        <div className="iframe-not-loading__div" style={loadingSpinnerStyle}>
          <img src={loadingSvgImage} alt="loading" />
          <p>Loading...</p>
        </div>
      );
    }

    // const dashboardName = this.props.dashboardName

    const iFrameContents = (
      <iframe
        id="dashFrame"
        width="100%"
        frameBorder="0"
        title={"User Guide iFrame"}
        key={this.keyID}
        src={this.guideURL}
        onLoad={this.iFrameLoaderListener}
      />
    );

    let dashboardIFrameDivLeftMargin = null;
    if (this.props.isSidebarCollapsed) {
      dashboardIFrameDivLeftMargin = { left: "0px" };
    }

    const pageContents = (
      // Note: The ID below needs to map to settings in src/index.scss
      <div id="dashboard-iframe__div" style={dashboardIFrameDivLeftMargin}>
        {iFrameNotLoadingInfoMessage}
        {iFrameContents}
      </div>
    );

    return (
        <DashboardPageContainer
          contents={pageContents}
          isSidebarCollapsed={this.props.isSidebarCollapsed}
        />
    );
  }
}

UserGuidePage.propTypes = {
  isSidebarCollapsed: PropTypes.bool.isRequired,
};

export default UserGuidePage;
